const pll = {
    prevSlideMessage: 'Zur vorherigen Folie gehen',
    nextSlideMessage: 'Zur nächsten Folie gehen',
    firstSlideMessage: 'Dies ist die erste Folie',
    lastSlideMessage: 'Dies ist die letzte Folie',
    paginationBulletMessage: 'Gehe zu Folie {{index}}'
};

export default pll;